import moment from 'moment';
import { get } from 'lodash';
export default {
    methods: {
        /**
          * Logs out the current user by dispatching the logout action in the store,
          * reloads permissions, and redirects to the home page if necessary.
          */

        logout() {
            this.$store.dispatch("logout")
                .then(success => {

                    this.$store.dispatch("loadPermissions");
                    if (this.$router.currentRoute.name !== "home") {
                        this.$router.push('/');
                    }


                })
                .catch(error => {
                    console.error(error);
                })


        },
        /**
         * Removes HTML tags from a given string.
         * 
         * @param {string} html - The HTML string to sanitize.
         * @returns {string} The plain text without HTML tags.
         */
        stripHtml(html) {
            if (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                return doc.body.textContent || "";
            } else {
                return "";
            }

        },
        /**
         * Formats a date string or object into 'DD.MM.YYYY'.
         * 
         * @param {string|Date} date - The date to format.
         * @returns {string} Formatted date or an empty string if input is invalid.
         */
        formatDate(date) {
            return date ? moment(date).format('DD.MM.YYYY') : ''
        },
        /**
        * Formats a date and time string or object into 'DD.MM.YYYY HH:mm'.
        * 
        * @param {string|Date} date - The date to format.
        * @returns {string|undefined} Formatted date-time string or undefined if no input.
        */
        formatDateTime(date) {
            if (date) {
                return moment(date).format("DD.MM.YYYY HH:mm"); // z. B. 05.03.2025 12:24
            }
        },
        /**
         * Decodes a string containing HTML entities into readable characters.
         * 
         * @param {string} str - The encoded string.
         * @returns {string} The decoded string.
         */
        decodeHTMLEntities(str) {
            const entities = {
                '&amp;': '&',
                '&lt;': '<',
                '&gt;': '>',
                '&quot;': '"',
                '&#39;': "'",
                '&apos;': "'",
                '&nbsp;': ' ',
            };
            return str.replace(/&[a-z#0-9]+;/gi, match => entities[match] || match);
        },
        /**
         * Translates a string key based on module and text key using the store's language strings.
         * Falls back to the key itself if translation is not found.
         * 
         * @param {string} mod - Module name (e.g., 'common').
         * @param {string} txt - Text key to translate.
         * @returns {string} Translated string or fallback key.
         */
        t(mod, txt) {
            const str = get(this.$store, `state.lang.strings[${mod}].${txt}`, `${mod}.${txt}`);
            return this.decodeHTMLEntities(str);
        },
        /**
         * Clears all values from an object.
         * 
         * @param {Object} obj - The object whose values should be cleared.
         */
        clearObjectValues(obj) {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    obj[key] = ""; // or obj[key] = undefined;
                }
            }
        },
        /**
         * Returns validation rules for smartsearch fields.
         * @returns {Object} - Contains the searchRules and plzRules.
         */
        getSearchValidationRules() {
            return [
                value => {
                    if (value.length < 5) {
                        return this.t('common', 'STR_ERR_SNRTOOSHORT'); // Translation usage
                    } else {
                        return true;
                    }
                }
            ];
        },
        /**
        * Converts a flat object to application/x-www-form-urlencoded format
        * Example: { a: '1', b: '2' } => "a=1&b=2"
        */
        toFormEncoded(obj) {
            return Object.entries(obj)
                .map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value))
                .join('&');
        },

        /**
         * Returns validation rules for PLZ fields.
         * @returns {Object} - Contains the searchRules and plzRules.
         */
        getPlzValidationRules() {
            return [
                value => {
                    if (!value) {
                        return this.t('common', 'STR_REQUIRED'); // Fehlertext
                    }
                    return true; // Erfolgreich validiert
                }
            ];
        },

        /**
         * Downloads a file from a given URL.
         * @param {string} url - The URL of the file to download.
         * @param {string} filename - Optional filename for the downloaded file.
         * @returns {void}
         */
        downloadFile(url, filename = null) {
            // Versucht per <a download> direkt zu laden
            const link = document.createElement('a');
            link.href = url;
            link.target = "_blank";

            // Optional Dateiname setzen
            if (filename) {
                link.setAttribute('download', filename);
            } else {
                link.setAttribute('download', '');
            }

            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        /**
        * Converts an object to an associative array.
        * 
        * @param {Object} obj - The object to convert.
        * @returns {Object} - The converted associative array.
        */
        objectToAssoc(obj) {
            let assoc = []
            Object.keys(obj).forEach(key => {
                var value = obj[key]
                assoc[key] = value
            });

            return assoc;
        }
        ,
        /**
        * Checks the properties of a shipment item.
        * 
        * @param {Object} item - The item to check properties for.
        * @returns {Boolean} - True if the item properties are valid, false otherwise.
        */

        checkProperty(item) {
            if (item) {
                return item;
            } else {
                return false;
            }

        }
        ,
        getLatLng(gpsString) {
            if (!gpsString) return null;
            const parts = gpsString.split(',');
            return {
                lat: parseFloat(parts[0].trim()),
                lng: parseFloat(parts[1].trim())
            };
        },
        
        getShipmentTypeNameById(id) {
            if (!id) return '';

            const shipmentTypes = this.$store?.state?.user?.shipmentTypes || [];

            for (const category of shipmentTypes) {
                const foundArt = category.arten?.find(a => a.id === id);
                if (foundArt) {
                    return foundArt.name; // "Nachtexpress", "Tagretoure", etc.
                }
            }

            return id; // Fallback, falls die ID im Store nicht existiert
        }

    },
};